export const SEARCH_ARCHIVED_INPUT_ITEM_ACTIVE = {
  archived: false,
  title: 'Search.ActiveKey',
}

export const SEARCH_ARCHIVED_INPUT_ITEM_ARCHIVED = {
  archived: true,
  title: 'Search.ArchivedKey',
}

export const SEARCH_ARCHIVED_INPUT_ITEMS = [
  SEARCH_ARCHIVED_INPUT_ITEM_ACTIVE,
  SEARCH_ARCHIVED_INPUT_ITEM_ARCHIVED,
]
